<script lang="ts">
    import { Component } from 'vue-facing-decorator';
    import Vue from "vue";
    import { strCompare, isNullOrWhitespace } from "@common/Common";
    import { PanelistReadModel } from '@Evaluation/Estimations/Domain/readmodels';
    import { dynamicUiRoutes } from '@common/dynamicUiRoutes';

    @Component({
        props: {
            Visible: Boolean,
            WorkspaceId: Number,
            ProjectId: Number,
            TargetingEnabled: Boolean,
            Tags: Array,
            Panelists: Array,
            
        }
    })
    export default class PanelistsSelector extends Vue
    {
        tag: string = null;        
        searchPhrase: string = null;

        get workspaceId(): number { return this.$props.WorkspaceId as number; }
        get tchProjectId(): number { return this.$props.ProjectId as number; }

        get panelistsView(): PanelistReadModel[]
        {
            let view = (this.$props.Panelists as PanelistReadModel[]).filter(a => a.IsArchived === false);

            if (!isNullOrWhitespace(this.searchPhrase))
            {
                const phrase = this.searchPhrase.toLowerCase();
                view = view.filter(a => (`${a.Name} ${a.Email}`).toLowerCase().indexOf(phrase) > -1);
            }

            if (this.tag)
            {
                view = view.filter(a => a.Tags.indexOf(this.tag) > -1);
            }

            view = view.sort((a, b) => strCompare(a.Name.toLowerCase(), b.Name.toLowerCase()));

            return view;
        }

        get tagLabel()
        {
            if (!isNullOrWhitespace(this.tag))
            {
                return `${this.tag}`;
            }

            return "Show all";
        }

        get url_PeoplePage(): string { return dynamicUiRoutes.ProjectUsers_PeoplePage(this.$route, this.workspaceId, this.tchProjectId); }

        selectTag(tag: string)
        {
            this.tag = tag;
        }

        excludePanelist(projectUserId: number)
        {
            this.$emit('excludePanelist', projectUserId)
        }

        includePanelist(projectUserId: number)
        {
            this.$emit('includePanelist', projectUserId)
        }

        showPanelistAlternativesSelector(projectUserId: number)
        {
            this.$emit('showPanelistAlternativesSelector', projectUserId)
        }

        close()
        {
            this.$emit('close')
        }
    }

</script>

<template>

    <div class="modal-mask" v-show="Visible">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add panelists</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body" style="min-height: 300px;">
                        <div v-if="Panelists.length === 0">
                            <p class="lead">
                                You currently have no Respondents set-up in the software. 
                                Please go to the <a class="text-primary" v-sanitizedHref="url_PeoplePage">People section</a> to upload names & emails.
                            </p>
                        </div>

                        <div v-if="Panelists.length > 0">
                            <nav class="navbar navbar-light navbar-expand-md bg-light" role="navigation">
                                <form class="form-inline my-2 my-lg-0 ml-auto" role="search">
                                    <input class="form-control form-control-sm mr-sm-2" type="search" placeholder="Search" v-model="searchPhrase">
                                </form>
                                <form class="form-inline my-2 my-lg-0 ">
                                    <div class="dropdown">
                                        <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown">
                                            <span>Filter by: {{tagLabel}}</span>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item" @click="selectTag(null)">Show all</a>
                                            <h6 class="dropdown-header">By tag:</h6>
                                            <a class="dropdown-item" v-for="t in Tags" @click="selectTag(t)">{{t}}</a>
                                        </div>
                                    </div>
                                </form>
                            </nav>

                            <table class="table">
                                <tbody>
                                    <tr v-for="p in panelistsView" :key="p.ProjectUserId">
                                        <td>
                                            <p class="fg-color-gray mb-0 mt-1">
                                                <span>{{p.Name}}</span>
                                            </p>
                                            <small class="text-muted" v-if="p.HasEmail">{{p.Email}}</small>
                                            <small class="text-danger" v-if="!p.HasEmail">Email not provided</small>
                                        </td>
                                        <td>
                                            <span class="badge badge-secondary mr-1" v-for="t in p.Tags" :key="t">{{t}}</span>
                                        </td>
                                        <td v-if="TargetingEnabled" style="width: 80px;">
                                            <button type="button" class="btn btn-outline-secondary" @click="showPanelistAlternativesSelector(p.ProjectUserId)" :disabled="!p.HasEmail">
                                                {{p.IsIncluded ? "Added" : "Add"}}
                                            </button>
                                        </td>
                                        <td v-if="!TargetingEnabled" style="width: 80px;">
                                            <button v-if="p.IsIncluded" type="button" class="btn btn-outline-danger" @click="excludePanelist(p.ProjectUserId)">Exclude</button>
                                            <button v-if="!p.IsIncluded" type="button" class="btn btn-outline-success" @click="includePanelist(p.ProjectUserId)">Include</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <a class="btn btn-outline-secondary" v-sanitizedHref="url_PeoplePage" target="_blank">Add people</a>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
